var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.roleAdmin === 'office-manager'|| 'accountant' || 'super-accountant' )?_c('MoneyBankOfficeManager'):_vm._e(),(_vm.roleAdmin === 'super-manager' )?_c('MoneyBankSuperManager'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }